import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { SwipeService } from './swipe.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { SVGLoaderComponent } from '../../_components/svg-loader/svg-loader.component';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor, NgClass } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-block-sectors-slider',
    templateUrl: './block-sectors-slider.component.html',
    styleUrls: ['./block-sectors-slider.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        NgClass,
        RouterLink,
        SVGLoaderComponent
    ],
    providers: [
        SwipeService
    ]
})
export class BlockSectorsSliderComponent implements AfterViewInit {
    @Input() name: {
        en: string,
        ar: string
    };
    @Input() cssClass: string;
    @Input() sectors: any[];

    public loaded: boolean = false;

    public activeItem = 0;
    public nextItem = 1;
    public prevItem = 2;

    private swipeCoord?: [number, number];
    private swipeTime?: number;

    constructor(
        private direction: DirectionService,
        private swipeService: SwipeService,
        public translate: TranslateService,
        public translationHelper: TranslateHelper
    ) {
    }

    ngAfterViewInit(): void {
        this.swipeService.currentMessage.pipe(untilDestroyed(this)).subscribe({
            next: (message) => {
                switch (message) {
                    case 'next': this.next(); break;
                    case 'previous': this.prev(); break;
                }
            }
        });

        _.forEach(this.sectors, (sector) => {
            sector['backgroundImage'] = null;
            if (sector.sectorImage?.url) {
                let url = encodeURI(sector.sectorImage?.url).replace('(', '%28').replace(')', '%29');
                sector['backgroundImage'] = `background-color: white; background-image: url(${url});`;
            }
        });

        this.prevItem = this.sectors.length - 1;
        this.loaded = true;
    }

    swipe(e: TouchEvent, when: string): void {
        let coord: [number, number] = [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
        let time = new Date().getTime();

        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
        }

        else if (when === 'end') {
            let direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
            let duration = time - this.swipeTime;
            if (duration < 1000 && Math.abs(direction[0]) > 30 && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
                if (direction[0] < 0) {
                    //next
                    this.swipeService.swipeNext();
                } else {
                    //previous
                    this.swipeService.swipePrevious();
                }
            }
        }
    }

    public next() {
        let next = this.nextItem + 1;
        if (next == this.sectors.length) {
            next = 0;
        }

        this.prevItem = this.activeItem;
        this.activeItem = this.nextItem;
        this.nextItem = next;
    }

    public prev() {
        let prev = this.prevItem - 1;
        if (prev == -1) {
            prev = this.sectors.length - 1;
        }

        this.nextItem = this.activeItem;
        this.activeItem = this.prevItem;
        this.prevItem = prev;
    }
}
